import React, { useState } from 'react';
import { Box, FormField, Select, RadioButtonGroup, TextInput } from 'grommet';

import { gql, useQuery } from '@apollo/client';

import Spinner from '../common/Spinner'


export const EdgeViewType = ({ viewPort, setViewPort }) => {
    return (
        <Box margin={{ top: "3px", bottom: "3px" }}>
            <RadioButtonGroup
                name="edgeviewtype"
                options={['MDTrader', 'MarketGrid', 'Table']}
                value={viewPort}
                onChange={(event) => setViewPort(event.target.value)}
            />
        </Box>
    )
}

export const MDSDropDown = ({ setTarget, envSelected }) => {

    const SEARCH_MDS = gql`
    query($env: String!) {
        node(
            where: {
                environment: { name: { _eq: $env } }
                serviceGroup_nodes: {
                    serviceGroup: {
                        group: { _eq: "price_server" }
                        services: { name: { _like: "mds_%" } }
                    }
                }
            }
            order_by: { name: asc }
        ) {
            name
        }
    }    
    `

    const result_edge = useQuery(
        SEARCH_MDS,
        { variables: { env: envSelected } }
    )
    const [finalSuggestions, setFinalSuggestions] = useState([])

    const onChange = event => {
        setTarget(event.target.value)
        onFilterSuggestion(event.target.value)
    }
    const onSelect = event => {
        setTarget(event.suggestion)
    }

    let suggestions = []

    if (result_edge.loading) {
        return (<Spinner />)
    }

    if (!result_edge.loading && result_edge.data) {
        result_edge.data.node.forEach(nodename => {
            suggestions.push(nodename.name)  
        })
    }

    const onFilterSuggestion = value => {
        setFinalSuggestions(
            suggestions.filter(
                suggestion => suggestion.toLowerCase().startsWith(value.toLowerCase()) > 0
            )
        )
    }

    return (
        <Box margin={{ top: "3px", bottom: "3px" }}>
            <FormField name="target">
                <TextInput
                    dropProps={{ height: "medium" }}
                    name="target"
                    suggestions={finalSuggestions.length > 0 ? finalSuggestions : suggestions}
                    plain
                    onChange={onChange}
                    onSelect={onSelect}
                />
            </FormField>
        </Box>
    )
}

export const EdgeServerDropDown = ({ setEdgeServer, envSelected }) => {

    const [options, setOptions] = useState([]);
    let defaultOptions = [];

    const SEARCH_EDGE = gql`
    query ($env: String!) {
        node(where: {environment: {name: {_eq: $env}}, serviceGroup_nodes: {serviceGroup: {group: {_eq: "edgeserver"}}}}, order_by: {name: asc}) {
            name
            datacenter {
                name
              }
            }
    }
    `

    const result_edge = useQuery(
        SEARCH_EDGE,
        { variables: { env: envSelected } }
    )

    let _options = []
    if (result_edge && !result_edge.loading) {
        result_edge.data.node.forEach(element => {
            _options.push(element.name)
        });
        defaultOptions = _options
    }

    // Set Target as Option
    const handleClick = (option) => {
        setValue(option)
        setEdgeServer([option])
    }
    const [value, setValue] = useState("");

    return (
        <Box margin={{ top: "3px", bottom: "3px" }}>
            {defaultOptions.length > 0 &&
                <FormField name="edgeserver">
                    <Select 
                        name="edgeserver"
                        options={options}
                        placeholder="select edgeserver"
                        value={value}
                        onOpen={() => setOptions(defaultOptions)}
                        onChange={({ option }) => handleClick(option)}
                        onSearch={text => {
                            const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
                            const exp = new RegExp(escapedText, "i");
                            setOptions(defaultOptions.filter(o => exp.test(o)));
                        }}
                    />
                </FormField>
            }
        </Box>
    )
}
